import type { Currency } from '@ps/web-core-enums';
import React from 'react';

import SuggestionsSelection from '../SuggestionsSelection/SuggestionsSelection';

import { TXTWCL_Suggested_amounts } from './AmountSuggestions.messages.json';

interface Props {
  suggestions: number[];
  currency: Currency;
}

const fieldName = 'deposit.amount';

const AmountSuggestions: React.FC<Props> = ({ suggestions = [], currency }) => {
  if (suggestions?.length === 0) return null;

  return (
    <SuggestionsSelection
      fieldName={fieldName}
      suggestions={suggestions}
      currency={currency}
      label={TXTWCL_Suggested_amounts}
    />
  );
};

export default AmountSuggestions;
